import api from "./apiWithAccessToken";

/* DB CONFIG CRUD */
export const getAllDBConfigs = () => api.get("/db_config/");
export const getDBConfigById = (id) => api.get(`/db_config/${id}`);
export const createDBConfig = (data) => api.post("/db_config/", data);
export const updateDBConfig = (id, data) => api.put(`/db_config/${id}`, data);
export const deleteDBConfig = (id) => api.delete(`/db_config/${id}`);

/* TEST CONNECTION */
export const testDBConfig = (payload) =>
  api.post("/db_config/test", payload);

/* LIVE EXPLORATION */
export const exploreLiveSchemas = (payload) =>
  api.post("/db/explore/test-schemas", payload);

export const exploreLiveTables = (payload) =>
  api.post("/db/explore/test-tables", payload);

/* TABLE EXPLORATION */
export const getCategorizedTables = (id) =>
  api.get(`/db/explore/${id}/selected-tables`);

export const saveSelectedTables = (id, tables) =>
  api.post(`/db/explore/${id}/select-tables`, {
    selected_tables: tables,
  });
  export const exploreTables = (id) =>
  api.get(`/db/explore/${id}/tables`);
